import React, { useEffect, useState } from 'react'
import Colors from '../../colors'
import { getDocsByCollectionAndFK } from '../../firebase';
import ModalContainer from './ModalContainer';
import { useNavigate } from 'react-router';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ModalButton from './Buttons/normal/ModalButton';


function TeamModal({ userId, defaultValue, isVisible, setIsVisible, dataCallback }) {
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(defaultValue.id !== '' ? defaultValue : null);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function getTeams() {
            if (userId === undefined) return;
            const teamsData = await getDocsByCollectionAndFK("Teams", 'userId', userId);
            setTeams(teamsData);
        }
        getTeams();
    }, [userId]);

    useEffect(() => {
        setSelectedTeam(defaultValue.id !== '' ? defaultValue : null);
    }, [isVisible, defaultValue]);

    const createTeamOnClickHandler = () => {
        navigate('/createTeam');
    };

    const checkForError = () => {
        if (selectedTeam === '' || selectedTeam === null) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2000)
            return true;
        } else {
            setError(false);
            return false;
        }
    };

    useEffect(() => {
        checkForError();
        // eslint-disable-next-line
    }, [selectedTeam])

    const saveButtonOnClickHandler = () => {
        if (!checkForError()) {
            dataCallback(selectedTeam);
            setIsVisible(false);
        }
    };


    const btnGroupStyles = {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    }

    const autocompleteStyles = {
        width: 300,
        border: error ? '2px solid red' : Colors.white,
    };

    return (
        <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={"Edit Team"}>
            <Autocomplete
                freeSolo
                selectOnFocus
                handleHomeEndKeys
                value={selectedTeam}
                onChange={(event, newValue) => {
                    setSelectedTeam(newValue)
                }}
                options={teams}
                sx={autocompleteStyles}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => <TextField {...params} label="Team" placeholder='Search Team by Name' />}
            />
            <div style={btnGroupStyles}>
                <ModalButton
                onClick={createTeamOnClickHandler}
                color={Colors.blue}
                fontSize={'1.1rem'} >
                    Create New Team
                </ModalButton>
                <ModalButton
                onClick={saveButtonOnClickHandler}
                color={Colors.green}
                fontSize={'1.1rem'} >
                    Save
                </ModalButton>
            </div>

        </ModalContainer>

    )
}

export default TeamModal;